import { Modulo } from '../../core/domain/modulo/modulo';
import { ModuloDto } from '../dto/modulo.dto';

export class ModuloMapper {
  static toDomain(moduloDto: ModuloDto): Modulo {
    return {
      id: moduloDto.id,
      descricao: moduloDto.descricao,
      ativo: moduloDto.ativo,
      idFuncionalidade: moduloDto.idFuncionalidade,
      mensagemNaoContratado: moduloDto.mensagemNaoContratado,
      imagemTelaNaoContratado: moduloDto.imagemTelaNaoContratado,
      indContratado: moduloDto.indContratado
    };
  }

  static toDTO(modulo: Modulo): ModuloDto {
    return {
      id: modulo.id,
      descricao: modulo.descricao,
      ativo: modulo.ativo,
      idFuncionalidade: modulo.idFuncionalidade,
      mensagemNaoContratado: modulo.mensagemNaoContratado,
      imagemTelaNaoContratado: modulo.imagemTelaNaoContratado,
      indContratado: modulo.indContratado
    };
  }
}
